module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/13.svg";